export function ShoppingBasket({ className }: { className?: string }) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1577 7.30744C23.2766 7.94679 23.6653 9.37212 23.0259 10.491L13.6926 26.8243C13.0533 27.9432 11.6279 28.3319 10.509 27.6926C9.39018 27.0532 9.00145 25.6279 9.64081 24.509L18.9741 8.17568C19.6135 7.0568 21.0388 6.66808 22.1577 7.30744Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.8424 7.30744C34.9613 6.66808 36.3866 7.0568 37.0259 8.17568L46.3593 24.509C46.9986 25.6279 46.6099 27.0532 45.491 27.6926C44.3722 28.3319 42.9468 27.9432 42.3075 26.8243L32.9741 10.491C32.3348 9.37212 32.7235 7.94679 33.8424 7.30744Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33337 25.6667C2.33337 24.378 3.37804 23.3333 4.66671 23.3333H51.3334C52.622 23.3333 53.6667 24.378 53.6667 25.6667C53.6667 26.9553 52.622 28 51.3334 28H4.66671C3.37804 28 2.33337 26.9553 2.33337 25.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.5891 23.3926C49.8451 23.6811 50.6293 24.9332 50.3408 26.1891L46.3778 43.4395L46.3757 43.4489C45.6631 46.6332 42.6017 49 39.4334 49H16.5879C14.9593 49.0268 13.372 48.4849 12.0997 47.467C10.8247 46.447 9.94644 45.0133 9.6168 43.4144L5.88607 26.1598C5.61374 24.9002 6.41404 23.6584 7.6736 23.386C8.93316 23.1137 10.175 23.914 10.4473 25.1736L14.1865 42.4671C14.2956 43.0021 14.5886 43.4819 15.015 43.823C15.4413 44.1641 15.9738 44.3448 16.5197 44.3338L16.5667 44.3333H39.4334C40.4619 44.3333 41.5976 43.4381 41.8223 42.4272L41.8259 42.4109L45.7926 25.1442C46.0811 23.8883 47.3332 23.104 48.5891 23.3926Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7424 23.3476C22.0231 23.2053 23.1768 24.1282 23.3191 25.409L25.6524 46.409C25.7947 47.6898 24.8718 48.8434 23.591 48.9857C22.3103 49.128 21.1566 48.2051 21.0143 46.9243L18.681 25.9243C18.5387 24.6436 19.4616 23.4899 20.7424 23.3476Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16671 36.1667C8.16671 34.878 9.21138 33.8333 10.5 33.8333H45.5C46.7887 33.8333 47.8334 34.878 47.8334 36.1667C47.8334 37.4553 46.7887 38.5 45.5 38.5H10.5C9.21138 38.5 8.16671 37.4553 8.16671 36.1667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2577 23.3476C36.5385 23.4899 37.4614 24.6436 37.3191 25.9243L34.9858 46.9243C34.8435 48.2051 33.6898 49.128 32.409 48.9857C31.1283 48.8434 30.2053 47.6898 30.3476 46.409L32.681 25.409C32.8233 24.1282 33.9769 23.2053 35.2577 23.3476Z"
        fill="currentColor"
      />
    </svg>
  )
}
